import type * as PdfjsLibType from 'pdfjs-dist';

let initPromise: Promise<typeof PdfjsLibType> | null = null;

export function getPdfLib(): Promise<typeof PdfjsLibType> {
	initPromise ??= import('pdfjs-dist').then((pdfjsLib) => {
		pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).href;
		return pdfjsLib;
	});
	return initPromise;
}
